import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeGetReceivingProgressItemIssueImagesParams,
  TypeGetReceivingProgressItemIssueImagesResponse,
} from '~/types/receive.types';

const fetchReceivingProgressItemIssueImages = async ({
  ownerCode,
  requestId,
  requestItemId,
}: TypeGetReceivingProgressItemIssueImagesParams): Promise<TypeGetReceivingProgressItemIssueImagesResponse> => {
  const { data } = await axiosInstance.get<TypeGetReceivingProgressItemIssueImagesResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/progress/${requestId}/items/${requestItemId}/issue-images`
  );
  return data;
};

/**
 * [입고관리 > 입고현황] 입고 현황 상세 > 이슈 이미지 조회 Mutation Hook
 */
export const useGetReceivingProgressItemIssueImagesMutation = () => {
  return useMutation({
    mutationFn: fetchReceivingProgressItemIssueImages,
  });
};
